// 站点 mock 数据：仅用于静态首页展示，均为公开信息整理的示意口径，不构成事实认定。
// 命名规范：一律使用具名导出（export const），不使用默认导出。

export interface TickerItem {
  text: string;
  time: string;
}

export interface TrackItem {
  id: string;
  hot: boolean;
  title: string;
  summary: string;
  tags: string[];
  status: "heat" | "responded" | "cleared" | "checking" | "turning";
  time: string;
  views: string;
}

export interface FactCheckRow {
  id: string;
  claim: string;
  source: string;
  status: "cleared" | "checking" | "unproven" | "responding";
  conclusion: string;
  note: string;
}

export interface TimelineStage {
  tag: string;
  title: string;
  detail: string;
  tone: "start" | "rise" | "doubt" | "respond" | "turn";
}

export interface ResponseItem {
  who: string;
  role: string;
  title: string;
  time: string;
  snippet: string;
}

export interface PrReview {
  title: string;
  outcome: string;
  kind: "good" | "warn";
}

export interface StatBlock {
  value: string;
  label: string;
  note: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const tickerItems: TickerItem[] = [
  { text: "深夜连麦『录音』引发争议，相关主播已发长文并附原始素材澄清。", time: "12 分钟前" },
  { text: "『解约跳槽』传言双方口径不一，聊天记录佐证仍在补充核对中。", time: "38 分钟前" },
  { text: "某带货投诉发酵后商家晒出送检报告，第三方结论等待复核。", time: "1 小时前" },
  { text: "流传的『后台数据截图』未标明采集时间，可信度存疑已标记。", time: "2 小时前" },
  { text: "同一事件被跨平台标题党二次搬运，已收录进辟谣核查清单。", time: "3 小时前" },
  { text: "完整录像放出后舆论方向明显转向，该事件进入反转复盘。", time: "4 小时前" },
  { text: "平台运营方就争议内容表态，称将依法依规核查并提示勿传谣。", time: "5 小时前" },
];

export const trackItems: TrackItem[] = [
  {
    id: "t1",
    hot: true,
    title: "深夜连麦『录音』疑云：从发酵到澄清的 48 小时",
    summary:
      "网传片段经网友逐帧比对被认为存在拼接，相关主播随后发布逐条回应并公开完整时间线与原始素材。我们把传播脉络、关键转折与双方口径整理在一起，供对照核实。",
    tags: ["录音争议", "连麦", "逐帧比对"],
    status: "responded",
    time: "更新于今日 09:20",
    views: "128w 阅读",
  },
  {
    id: "t2",
    hot: true,
    title: "『解约跳槽』传言：平台与公会口径不一，证据仍在补充",
    summary: "双方对合同节点说法不同，流出聊天记录暂未获确认，事件仍在追踪。",
    tags: ["合同", "跳槽"],
    status: "heat",
    time: "2 小时前",
    views: "64w 阅读",
  },
  {
    id: "t3",
    hot: false,
    title: "『货不对板』投诉发酵：商家晒质检报告，待第三方复核",
    summary: "产品资质照片已公开，但送检方与批次仍需核实，暂不轻易定性。",
    tags: ["带货", "质检"],
    status: "checking",
    time: "4 小时前",
    views: "41w 阅读",
  },
  {
    id: "t4",
    hot: false,
    title: "『后台数据截图』疑点：未标注采集时间，真实性存疑",
    summary: "截图来源不明、无法定位原始页面，目前无法作为可信依据。",
    tags: ["数据", "截图"],
    status: "checking",
    time: "5 小时前",
    views: "23w 阅读",
  },
  {
    id: "t5",
    hot: false,
    title: "跨平台标题党二次搬运：同一事件被改头换面传播",
    summary: "原始话题已被官方澄清，但搬运号仍用旧标题制造新热度，已收录标记。",
    tags: ["标题党", "搬运"],
    status: "cleared",
    time: "6 小时前",
    views: "36w 阅读",
  },
  {
    id: "t6",
    hot: true,
    title: "直播间口误被恶意放大：完整录像流出后舆论反转",
    summary: "单句被单独截取放大，完整回放公开后讨论方向发生明显变化。",
    tags: ["口误", "反转"],
    status: "turning",
    time: "7 小时前",
    views: "58w 阅读",
  },
  {
    id: "t7",
    hot: false,
    title: "网传『封禁名单』截图流传，平台暂未正面回应",
    summary: "名单截图出处不明，页面无法回溯，事件状态标注为待核实。",
    tags: ["封禁", "名单"],
    status: "checking",
    time: "8 小时前",
    views: "17w 阅读",
  },
];

export const factChecks: FactCheckRow[] = [
  {
    id: "f1",
    claim: "网传『某主播已封号退网』",
    source: "社交平台截图",
    status: "cleared",
    conclusion: "已辟谣",
    note: "当事人账号正常，已晒状态并正常开播；截图系旧图重发。",
  },
  {
    id: "f2",
    claim: "网传『某产品检测不合格』",
    source: "两年前旧闻",
    status: "cleared",
    conclusion: "旧闻重发",
    note: "检测报告日期为两年前，内容与近期事件无关。",
  },
  {
    id: "f3",
    claim: "网传『巨额赔付金额』",
    source: "账号发帖",
    status: "unproven",
    conclusion: "无实据",
    note: "具体金额未获任何一方确认，仅停留在口头说法。",
  },
  {
    id: "f4",
    claim: "网传『深夜录音为剪辑』",
    source: "逐帧比对",
    status: "responding",
    conclusion: "已回应",
    note: "当事人提供原始素材与完整时间线，关键节点可回溯。",
  },
  {
    id: "f5",
    claim: "网传『平台封禁名单截图』",
    source: "来源不明截图",
    status: "checking",
    conclusion: "待核实",
    note: "原始页面无法回溯，暂不能作为可信依据。",
  },
];

export const timelineStages: TimelineStage[] = [
  {
    tag: "阶段一 · 初传",
    title: "深夜片段流出",
    detail: "一段被冠以『惊人内幕』标题的录音/画面在多个账号间扩散，热度快速上升。",
    tone: "start",
  },
  {
    tag: "阶段二 · 发酵",
    title: "二次解读放大",
    detail: "不同账号配以不同字幕与情绪化导语二次转引，事件从『存疑』被推向『定性』。",
    tone: "rise",
  },
  {
    tag: "阶段三 · 质疑",
    title: "逐帧比对起疑",
    detail: "网友开始比对时间轴与画面，指出多个与公开信息对不上的关键节点。",
    tone: "doubt",
  },
  {
    tag: "阶段四 · 回应",
    title: "当事人长文澄清",
    detail: "相关主播发布长文并附原始素材与时间线，对关键质疑逐条说明。",
    tone: "respond",
  },
  {
    tag: "阶段五 · 转向",
    title: "完整版本放出",
    detail: "完整回放公开后舆论方向明显转变，最早制造情绪的那批标题被陆续标记。",
    tone: "turn",
  },
];

export const responses: ResponseItem[] = [
  {
    who: "相关主播",
    role: "事件当事人",
    title: "长文回应附时间线",
    time: "今日 08:10",
    snippet: "附原始素材与逐条回应，说明关键片段的前后语境，公开完整时间线供核对。",
  },
  {
    who: "涉事品牌方",
    role: "带货关联方",
    title: "补充说明送检记录",
    time: "今日 11:40",
    snippet: "公开产品送检记录，表示接受第三方监督，并回应批次与抽检口径疑问。",
  },
  {
    who: "平台运营方",
    role: "平台侧",
    title: "官方声明与提示",
    time: "今日 13:05",
    snippet: "表示将依法依规核查相关争议内容，并提示公众勿传播未经核实的信息。",
  },
];

export const prReviews: PrReview[] = [
  {
    title: "回应速度偏慢",
    outcome: "声明晚于舆论峰值约 6 小时，留出情绪发酵窗口。",
    kind: "warn",
  },
  {
    title: "证据优先于表态",
    outcome: "用逐帧时间线与原始素材回应，而非口号式否认，说服力更强。",
    kind: "good",
  },
  {
    title: "标题党利用情绪",
    outcome: "把『疑问』写成『实锤』，让立场先行于事实。",
    kind: "warn",
  },
  {
    title: "事后处置与公示",
    outcome: "对拼接搬运账号作标记处理并公示，降低二次传播。",
    kind: "good",
  },
];

export const statBlocks: StatBlock[] = [
  { value: "128", label: "累计追踪事件", note: "持续归档与更新" },
  { value: "74", label: "已核实 / 已澄清", note: "含旧闻与误导标记" },
  { value: "19", label: "待核实事件", note: "缺少可回溯证据" },
  { value: "68%", label: "当事人回应率", note: "声明口径覆盖度" },
];

export const faqs: FaqItem[] = [
  {
    q: "这里的『辟谣 / 反转』状态是谁判定的？",
    a: "由我们把当事人回应、平台声明与多方公开素材对照后整理归纳得出，仅代表当前公开信息的整理状态，会随后续进展持续更新，不构成事实认定。任何单方说法都不应被当作最终结论。",
  },
  {
    q: "为什么同一事件会出现『反转又反转』？",
    a: "片段化传播、标题与字幕再加工、回应信息分批披露，都会让同一事件的信息不断刷新。追过程比追单个结论更重要。",
  },
  {
    q: "看到网传『实锤』截图该怎么判断？",
    a: "先看三件事：截图是否标注采集时间与出处、原始页面能否回溯、是否与当事人/平台的一手信息对得上。三者缺其一，都建议先标注待核实。",
  },
  {
    q: "以前『未证实』的内容你们会删除吗？",
    a: "不会删除，而是用状态标注留存，便于回溯某个说法在何时被修正或澄清，也能看清信息版本是怎么演进的。",
  },
  {
    q: "想提交线索或纠错怎么做？",
    a: "通过页面中的联系入口与我们核对即可（本页为示意入口）。提供原始链接与时间点会显著提升核对效率。",
  },
  {
    q: "版权与免责说明",
    a: "页面内容均为公开信息梳理与状态示意，引述素材版权归原作者所有；请以官方渠道信息为准，勿将本页归纳当作事实定论。",
  },
];

export const navLinks = [
  { href: "#tracking", label: "事件追踪" },
  { href: "#factcheck", label: "辟谣核查" },
  { href: "#reversal", label: "反转复盘" },
  { href: "#response", label: "当事人回应" },
  { href: "#data", label: "追踪数据" },
  { href: "#faq", label: "常见问题" },
];